import { Component, OnInit } from '@angular/core';
import { Global } from "../../classes/global";

@Component({
  selector: 'app-auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {

  constructor(public global: Global) {
  }

  ngOnInit(): void {
  }

}
